module.exports = __webpack_public_path__ + "static/img/banner-5.3011c1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-5.png
// module id = qDXl
// module chunks = 1